import { defineFcm } from '../shared/factory';

export const FCM_PROMOTIONS_SHOW_ALL_PROMOTIONS_AT_START_OF_CAROUSEL = defineFcm(
	'promotions_show_all_promotions_at_start_of_carousel',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-middle-end',
		context: 'Petition discover page (carousel)',
		description: 'Defines whether the promoted petition cards should be shown before any other petition card.',
		import: false,
	});
